var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDarkmode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 48,
    viewBox: "0 0 160 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3420:7233)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2461 30.3512C26.2446 31.81 23.0987 32.0954 20.8433 30.9538C17.9194 29.4312 16.7446 26.2281 17.0936 23.1837C17.3803 21.0903 18.746 19.3142 20.5254 18.2045C22.5269 17.0621 25.3869 16.9991 27.4841 18.0139C29.8034 19.2512 31.4239 21.7248 31.392 24.452C31.2642 26.7989 30.4072 29.0191 28.2461 30.3512ZM48 25.4931L36.259 13.655L41.5964 8.32738L25.6089 8.27795V0L13.8072 11.7321L8.6742 6.59669L8.64784 22.7397H0L11.6196 34.416L5.61615 40.4977H22.7385L22.7832 48L34.1026 36.7366L39.8761 42.5696L39.9056 25.4931H48Z",
    fill: "#FED203"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.204 32.2017C53.9496 32.2017 52.1992 31.2577 52.1992 28.7561V25.8073H59.2256V27.0817C59.2256 27.8841 59.5136 28.2849 60.1136 28.2849C60.6888 28.2849 60.9768 27.4825 61 26.8217C61.0248 26.0665 60.6408 25.4297 59.9216 25.1465L54.7656 23.0937C53.4704 22.5745 52.1992 21.7489 52.1992 19.9785V18.0201C52.1992 15.5193 53.9496 14.5513 56.204 14.5513H64.0216C66.276 14.5513 68.0272 15.5193 68.0272 18.0201V19.8841H61V19.6953C61 18.9873 60.6648 18.4921 60.1136 18.4921C59.6336 18.4921 59.2256 18.8929 59.2256 19.3649C59.2256 19.8841 59.6336 20.1673 60.1136 20.3801L65.9888 22.8105C67.4272 23.4233 68.0272 24.6745 68.0272 26.2553V28.7561C68.0272 31.2577 66.276 32.2017 64.0216 32.2017H56.204Z",
    fill: "#FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.6424 32.2017H73.0408C70.7864 32.2017 69.0352 31.2577 69.0352 28.7561V14.6697H75.9664V27.0817C75.9664 27.8841 76.2304 28.2849 76.8296 28.2849C77.4296 28.2849 77.7168 27.9073 77.7168 27.0817V14.6697H84.624V28.7561C84.624 31.2577 82.8968 32.2017 80.6424 32.2017Z",
    fill: "#FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.8168 32.0841L92.7712 23.8961V32.0841H86.4648V14.6697H93.2984L96.0328 21.8425V14.6697H102.316V32.0841H95.8168Z",
    fill: "#FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.407 26.0433C112.407 25.2881 112.119 24.8873 111.472 24.8873H110.657V28.1201H111.472C112.119 28.1201 112.407 27.7185 112.407 26.9865V26.0433ZM111.472 18.6337H110.657V21.1113H111.472C112.119 21.1113 112.407 20.7569 112.407 19.8841C112.407 18.9641 112.119 18.6337 111.472 18.6337ZM115.357 32.0841H103.727V14.6697H115.357C117.995 14.6697 119.434 15.8729 119.434 18.8465C119.434 20.6393 118.859 22.2913 116.556 22.7633C118.763 23.2825 119.434 24.9105 119.434 27.6241C119.434 30.9745 117.995 32.0841 115.357 32.0841Z",
    fill: "#FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.832 32.0841V14.6697H132.008V18.6337H127.763V20.5449H132.008V24.5089H127.763V28.1201H132.008V32.0841H120.832Z",
    fill: "#FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.789 32.0841V14.6697H140.719V28.1201H144.964V32.0841H133.789Z",
    fill: "#FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.378 18.6337V32.0841H146.471V18.6337H142.898V14.6697H156.928V18.6337H153.378Z",
    fill: "#FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.8672 40.5521H68.78V38.9313H71.788C72.3824 38.9313 72.572 39.1473 72.572 39.8025V40.5521H74.4856V39.4913C74.4856 38.4665 74.0112 38.2153 73.4424 38.1129V38.0953C74.3216 37.8881 74.5112 37.3977 74.5112 36.5617V36.1649C74.5112 35.0449 74.1152 34.3113 72.6408 34.3113H66.8672V40.5521ZM68.78 35.8633H71.7704C72.3736 35.8633 72.6496 35.9673 72.6496 36.5185V36.7249C72.6496 37.1737 72.46 37.3801 71.9432 37.3801H68.78V35.8633Z",
    fill: "#FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.4961 40.5521H85.4337V39.0529H80.4089V38.0529H85.0641V36.7601H80.4089V35.7593H85.3217V34.3113H78.4961V40.5521Z",
    fill: "#FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.2812 40.5521H91.194V36.0185H91.2116L94.8052 40.5521H97.77V34.3113H95.8572V38.8457H95.8396L92.246 34.3113H89.2812V40.5521Z",
    fill: "#FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.297 35.8633H103.986V40.5521H105.898V35.8633H108.587V34.3113H101.297V35.8633Z",
    fill: "#FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.487 35.7593L116.728 38.1041H114.28L115.487 35.7593ZM110.867 40.5521H113.005L113.566 39.4489H117.443L118.038 40.5521H120.166L116.736 34.3113H114.246L110.867 40.5521Z",
    fill: "#FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.539 40.5521H129.753V38.9489H125.453V34.3113H123.539V40.5521Z",
    fill: "#FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.145 38.94C133.145 40.2928 133.842 40.62 135.585 40.62H137.901C140.444 40.62 141.013 40.3448 141.013 38.6648C141.013 36.8456 140.322 36.6648 137.35 36.6728C135.299 36.6824 135.067 36.6648 135.067 36.1216C135.067 35.7864 135.36 35.6392 135.791 35.6392H137.911C138.789 35.6392 138.841 35.8288 138.841 36.2848H140.753V36.0872C140.753 34.9928 140.547 34.2432 138.342 34.2432H135.67C133.258 34.2432 133.153 35.1136 133.153 36.2424C133.153 37.7768 133.482 38.1216 136.36 38.1216C138.824 38.1216 139.047 38.156 139.047 38.6992C139.047 39.1808 138.633 39.224 138.229 39.224H135.885C135.333 39.224 135.067 39.1728 135.058 38.5096H133.145V38.94Z",
    fill: "#FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.608 29.9064H156.928C157.292 29.9064 157.601 29.7744 157.601 29.4328C157.601 29.1888 157.425 28.9472 156.928 28.9472C156.783 28.9472 156.684 28.9576 156.608 28.9688V29.9064ZM156.608 31.4408H156.165V28.6704C156.398 28.6376 156.617 28.604 156.949 28.604C157.369 28.604 157.644 28.692 157.809 28.8144C157.974 28.936 158.064 29.1232 158.064 29.388C158.064 29.752 157.821 29.9728 157.523 30.0608V30.0832C157.766 30.1264 157.931 30.3488 157.986 30.756C158.052 31.1864 158.118 31.3528 158.164 31.4408H157.698C157.632 31.3528 157.568 31.0984 157.512 30.7344C157.445 30.3816 157.269 30.2488 156.917 30.2488H156.608V31.4408ZM157.071 27.8984C155.976 27.8984 155.085 28.836 155.085 29.9952C155.085 31.176 155.976 32.1032 157.081 32.1032C158.185 32.1144 159.068 31.176 159.068 30.0056C159.068 28.836 158.185 27.8984 157.081 27.8984H157.071ZM157.081 27.5112C158.437 27.5112 159.521 28.616 159.521 29.9952C159.521 31.3968 158.437 32.4888 157.071 32.4888C155.713 32.4888 154.609 31.3968 154.609 29.9952C154.609 28.616 155.713 27.5112 157.071 27.5112H157.081Z",
    fill: "#FFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3420:7233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 48,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkmode);
export default __webpack_public_path__ + "static/media/darkmode.fb98bdb41a1c15326963740ac761d8cc.svg";
export { ForwardRef as ReactComponent };